import { ChangeDetectionStrategy, Component, inject, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogModule, MatDialogTitle } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TreeAutocompleteComponent } from "../tree-autocomplete/tree-autocomplete.component";
import { ScnackbarData, SnackbarStyles, ToastService } from '../toast.service';
import { ParticipanteService } from '../../services/participante.service';
import { UnidadOrganizacionalService } from '../../services/unidad-organizacional.service';
import { departamentoValidator } from './../reasignar/reasignar.component';
import { UnidadOrganizacional } from '../../models/UnidadOrganizacional';
import { AuthService } from '../../services/auth.service';
import { ServidorPublico } from '../../models/ServidorPublico';
import { map, Observable, startWith } from 'rxjs';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { UltimoUsoPipe } from '../../pipes/ultimo-uso.pipe';
import { AsyncPipe, CommonModule } from '@angular/common';
import { ReportService } from '../../services/report.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FilesService } from '../../shared/files.service';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DateService, MY_DATE_FORMATS } from '../../shared/date.service';
import { ChangeDetectorRef } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-dlg-reporte',
    imports: [CommonModule, MatDialogModule, MatButtonModule,
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatDialogClose,
      HttpClientModule,
        MatFormFieldModule, MatInputModule, MatDatepickerModule, TreeAutocompleteComponent,
      MatSelectModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        MatIconModule,
        AsyncPipe,
        UltimoUsoPipe,
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'es-EC' },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './dlg-reporte.component.html',
    styleUrl: './dlg-reporte.component.scss'
})
export class DlgReporteComponent {
  private readonly reportFriendlyNames: Record<string, string> = {
    rptListadoDocumento: 'Listado_documentos_enviados',
    rpListadoMisTramitesRegistradosPeriodo: 'Listado_mis_tramites_registrados_periodo',
    rptListadoDeptFuncionario: 'Listado_documentos_por_departamento_funcionario',
    rptListadoDocumentoDeptFuncionario: 'Listado_recibidos_departamental',
    rptBuzonesDeptFuncionarios: 'Listado_buzones_funcionarios_departamento',
    rptEstadisticoDeptFuncionario: 'Estadistico_documentos_departamento_funcionario',
    rptEstadisticoDeptFuncionarioTiempo: 'Estadistico_tiempo_atencion',
    rptEstadisticoTareasDepartamental: 'Listado_tareas_pendientes_departamento',
    rptListadoTramitesGeneralPeriodo: 'Listado_tramites_general_periodo',
    rpListadoTramitesGeneralPorDocumentoPeriodo: 'Listado_tramites_por_tipo_documento',
    rpListadoTramitesTipoPeriodo: 'Listado_tramites_por_numeracion',
    rptListadoTareasParticipantePeriodo: 'Listado_tareas_pendientes_personal',
    rpTareasAbiertasParticipante: 'Tareas_abiertas_participante',
    rpListadoHojaGuia: 'Listado_hoja_guia_enviados',
    rpListadoHojaGuiaReasigna: 'Listado_hoja_guia_reasignados',
    rpListadoHojaGuiaTarea: 'Listado_hoja_guia_tareas',
    rptGrafTramiteMes: 'Estadistico_grafico_tramite_mensual',
    rptGrafTramiteDocumento: 'Estadistico_grafico_tipo_documento',
    rptTrazabilidadTramite: 'Trazabilidad_documento',
    rptRecepcionTramiteAmpliado: 'Recepcion_tramite',
    rpTiempoAtencionXLS: 'Listado_tramites_tiempo_atencion',
  };

  currentUserID: string;
  currentUserRoles: string;
  participantes: ServidorPublico[] = []
  participantesFiltered?: Observable<ServidorPublico[]>
  dsDepartamentos: UnidadOrganizacional[] = []

  departamentos: UnidadOrganizacional[] = []
  departamentosFiltered?: Observable<UnidadOrganizacional[]>

  snackbarData: ScnackbarData = {}
  readonly dialog = inject(MatDialog);

  frmReporte = new FormGroup({
    departamento: new FormControl<UnidadOrganizacional>({ id: "", nombre: "", tipo: 0 }, {
    }),
    participante: new FormControl<ServidorPublico>({ id: 0, usuario: "", apellidos: "", nombres: "", correo: "", estado: 0, telefono: "", telefonoMovil: "", departamento: "", cargo: "", titulo: "", ciruc: "", fechaUso: "" }, {
    }),
    anio: new FormControl<number | null>(new Date().getFullYear(), {
      validators: [Validators.min(0)]
    }),
    numero: new FormControl<number | null>(null, {
      validators: [Validators.min(0)]
    }),
    fechaInicio: new FormControl(new Date(new Date().setDate(new Date().getDate())), {
      validators: [Validators.required]
    }),
    fechaFin: new FormControl(new Date(new Date().setDate(new Date().getDate() + 1)), {
      validators: [Validators.required]
    }),
    horaInicio: new FormControl<string>('00:00'),
    horaFin: new FormControl<string>('23:59'),
    codigoTipoDoc: new FormControl<string>('-100'),
    filtroTramite: new FormControl<string>('1'),
  })

  constructor(
    private participanteService: ParticipanteService,
    private unidadOrganizacionalService: UnidadOrganizacionalService,
    private authService: AuthService,
    private dateService: DateService,
    private reportService: ReportService,
    private toast: ToastService,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private filesService: FilesService,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.currentUserID = this.authService.getTokenData()!.id;
    this.currentUserRoles = this.authService.getTokenData()!.roles;
  }

  // viewer state
  blobUrl: string | null = null;
  blobSafeUrl: SafeResourceUrl | null = null;
  loadingReport: boolean = false;

  closeViewer() {
    if (this.blobUrl) {
      try { URL.revokeObjectURL(this.blobUrl); } catch (e) {}
    }
    this.blobUrl = null;
    this.blobSafeUrl = null;
  }

  openInNewTab() {
    if (this.blobUrl) {
      window.open(this.blobUrl, '_blank');
    }
  }

  private parseFilenameFromContentDisposition(contentDisposition: string | null): string | null {
    if (!contentDisposition) {
      return null;
    }

    const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match?.[1]) {
      try {
        return decodeURIComponent(utf8Match[1]).replace(/(^\"|\"$)/g, '').trim();
      } catch (e) {
        return utf8Match[1].replace(/(^\"|\"$)/g, '').trim();
      }
    }

    const plainMatch = contentDisposition.match(/filename=([^;]+)/i);
    if (plainMatch?.[1]) {
      return plainMatch[1].replace(/(^\"|\"$)/g, '').trim();
    }

    return null;
  }

  private sanitizeFilename(name: string): string {
    const safe = (name || '').trim().replace(/[\\/:*?"<>|]/g, '_');
    return safe || 'reporte.pdf';
  }

  private getExtensionFromUrl(url: string): string {
    try {
      const parsed = new URL(url, window.location.origin);
      const tipoReporte = parsed.searchParams.get('tipoReporte');
      if (tipoReporte && tipoReporte.toLowerCase() === 'xls') {
        return 'xls';
      }
    } catch (e) {
      if (url.toLowerCase().includes('tiporeporte=xls')) {
        return 'xls';
      }
    }
    return 'pdf';
  }

  private formatDateForFilename(date: Date | null | undefined): string | null {
    if (!date) {
      return null;
    }
    const d = new Date(date);
    if (Number.isNaN(d.getTime())) {
      return null;
    }
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private usesDateRangeInFileName(reportKey: string): boolean {
    const withRange = new Set([
      'rptListadoDocumento',
      'rptListadoDeptFuncionario',
      'rptListadoDocumentoDeptFuncionario',
      'rptEstadisticoDeptFuncionario',
      'rptEstadisticoDeptFuncionarioTiempo',
      'rptEstadisticoTareasDepartamental',
      'rptListadoTramitesGeneralPeriodo',
      'rpListadoTramitesGeneralPorDocumentoPeriodo',
      'rpListadoTramitesTipoPeriodo',
      'rptListadoTareasParticipantePeriodo',
      'rpTiempoAtencionXLS',
      'rptGrafTramiteDocumento',
    ]);
    return withRange.has(reportKey);
  }

  private buildSuggestedFilename(url: string): string {
    const reportKey = (this.data?.key || this.data?.reportName || 'reporte').toString();
    const base = this.reportFriendlyNames[reportKey] || reportKey;
    const extension = this.getExtensionFromUrl(url);

    let suffix = '';
    if (this.usesDateRangeInFileName(reportKey)) {
      const from = this.formatDateForFilename(this.frmReporte.controls.fechaInicio.value as Date | null);
      const to = this.formatDateForFilename(this.frmReporte.controls.fechaFin.value as Date | null);
      if (from && to) {
        suffix = from === to ? `_${from}` : `_${from}_a_${to}`;
      } else if (from) {
        suffix = `_${from}`;
      }
    }

    if (!suffix) {
      const now = this.formatDateForFilename(new Date());
      suffix = now ? `_${now}` : '';
    }

    return this.sanitizeFilename(`${base}${suffix}.${extension}`);
  }

  openReportBlob(url: string) {
    console.log('[DlgReporte] openReportBlob url=', url);
    
    // Conditional logic: development opens URL directly, production opens as blob.
    if (!environment.production) {
      // Development: simple direct open in new tab
      console.log('[DlgReporte] development mode: opening URL directly');
      try {
        window.open(url, '_blank');
      } catch (e) {
        console.error('[DlgReporte] error opening URL in new tab', e);
        this.snackbarData.message = 'Error abriendo el reporte en nueva pestaña.';
        this.snackbarData.style = SnackbarStyles.Error;
        this.toast.show(this.snackbarData);
      }
      return;
    }

    // Production: fetch blob and open in new tab
    console.log('[DlgReporte] production mode: opening as blob');
    // Try to open a blank tab first (user gesture), then fetch the blob and assign the object URL to it.
    let newWin: Window | null = null;
    try {
      newWin = window.open('about:blank');
    } catch (e) {
      newWin = null;
    }

    if (newWin) {
      // Fetch blob and navigate the new window to the object URL
      this.loadingReport = true;
      this.http.get(url, { responseType: 'blob', observe: 'response' }).subscribe({
        next: (response) => {
          try {
            const blob: Blob = response.body as Blob;
            const disposition = response.headers.get('Content-Disposition');
            const serverFilename = this.parseFilenameFromContentDisposition(disposition);
            const fallbackFilename = this.buildSuggestedFilename(url);
            const fileName = this.sanitizeFilename(serverFilename || fallbackFilename);

            const namedBlob = new File([blob], fileName, {
              type: blob.type || 'application/pdf'
            });
            const objectUrl = URL.createObjectURL(namedBlob);

            // navigate the opened tab to the blob URL
            try {
              newWin.location.href = objectUrl;
            } catch (e) {
              // some browsers may restrict setting location; fallback to replace
              newWin.location.replace(objectUrl);
            }
            // Keep blob URL long enough so browser PDF viewer can still download it later.
            setTimeout(() => {
              try { URL.revokeObjectURL(objectUrl); } catch (e) {}
            }, 1800000);
          } catch (ex) {
            console.error('[DlgReporte] error opening blob in new tab', ex);
            this.snackbarData.message = 'Error abriendo el reporte en nueva pestaña.';
            this.snackbarData.style = SnackbarStyles.Error;
            this.toast.show(this.snackbarData);
            try { newWin.close(); } catch (e) {}
          } finally {
            this.loadingReport = false;
          }
        },
        error: (err) => {
          console.error('[DlgReporte] http error fetching blob for new tab', err);
          this.loadingReport = false;
          this.snackbarData.message = 'Error generando el reporte.';
          this.snackbarData.style = SnackbarStyles.Error;
          this.toast.show(this.snackbarData);
          try { newWin.close(); } catch (e) {}
        }
      });
    } else {
      // popup blocked or could not open — fallback to download
      console.warn('[DlgReporte] popup blocked or could not open, falling back to blob download');
      this.loadingReport = true;
      this.http.get(url, { responseType: 'blob' }).subscribe({
        next: (blob: Blob) => {
          try {
            const filename = this.buildSuggestedFilename(url);
            this.filesService.openFileFromOctectStream({ blob: blob, filename }, false);
          } catch (ex) {
            console.error('[DlgReporte] error opening blob fallback', ex);
            this.snackbarData.message = 'Error abriendo el reporte.';
            this.snackbarData.style = SnackbarStyles.Error;
            this.toast.show(this.snackbarData);
          } finally {
            this.loadingReport = false;
          }
        },
        error: (err) => {
          console.error('[DlgReporte] http error fetching blob fallback', err);
          this.loadingReport = false;
          this.snackbarData.message = 'Error generando el reporte.';
          this.snackbarData.style = SnackbarStyles.Error;
          this.toast.show(this.snackbarData);
        }
      });
    }
  }

  ngOnInit(): void {
    this.frmReporte.controls.participante.disable()
    const isAdmin = this.currentUserRoles?.includes('sgd_admin');
    // If this dialog is opened for the buzones report, use the public full-tree endpoint; otherwise follow admin/hierarchical logic
    const forceAllForBuzones = this.data && this.data.key === 'rptBuzonesDeptFuncionarios';

    if (forceAllForBuzones) {
      this.unidadOrganizacionalService.getUoTodosPublic().subscribe({
        next: (response) => { this.dsDepartamentos = response || []; try { this.cdr.markForCheck(); } catch (e) {} },
        error: () => {
          // fallback to flat list
          this.unidadOrganizacionalService.listDepartamentos().subscribe({ next: (r) => { this.dsDepartamentos = r || []; try { this.cdr.markForCheck(); } catch (e) {} }, error: () => { this.dsDepartamentos = []; try { this.cdr.markForCheck(); } catch (e) {} } })
        }
      })
    } else {
      const treeObs = isAdmin
        ? this.unidadOrganizacionalService.getAllDepartamentosTree()
        : this.unidadOrganizacionalService.getDepartamentosTree();
      treeObs.subscribe({ next: (response) => { this.dsDepartamentos = response }, error: () => { this.dsDepartamentos = [] } })
    }
  }

  hasParam(name: string): boolean {
    return this.data?.params?.some((item:any) => item.id === name) || false;
  }

  trackDepartamentoChanges(value: any) {
    if ((value as UnidadOrganizacional).id) {
      this.frmReporte.controls.departamento.setValue(value as UnidadOrganizacional);

      if (this.isEstadisticoDepartamentalReport) {
        this.participantes = []
        this.participantesFiltered = undefined
        this.frmReporte.controls.participante.setValue(null)
        this.frmReporte.controls.participante.disable()
        return;
      }

      this.participanteService.getServidoresPorDepartamento((value as UnidadOrganizacional).id).subscribe({
        next: (response) => {
          if (response.length > 0) {
            response.sort(function (a, b) {
              if (a.apellidos > b.apellidos) { return 1; }
              if (a.apellidos < b.apellidos) { return -1; }
              return 0;
            });
            this.participantes = response
            this.participantesFiltered = this.frmReporte.controls.participante.valueChanges.pipe(
              startWith(''),
              map(value => {
                const nombres = typeof value === 'string' ? value : value?.nombres;
                return nombres ? this._filterParticipante(nombres as string) : this.participantes.slice();
              }),
            );
            this.frmReporte.controls.participante.enable()
          } else {
            this.snackbarData.message = "Sin usuarios en el departamento!"
            this.snackbarData.style = SnackbarStyles.Error
            this.snackbarData.iconName = "error"
            this.toast.show(this.snackbarData)
          }
        }
      })
    } else {
      this.frmReporte.controls.departamento.setValue({ id: "", nombre: "", tipo: 0 });
      this.participantes = []
      this.participantesFiltered = undefined
      this.frmReporte.controls.participante.setValue(null)
    }
  }

  displayParticipanteFn(participante: ServidorPublico): string {
    return participante && participante.nombres ? participante.nombres.trim() + ' ' + participante.apellidos.trim() : '';
  }

  private _filterParticipante(filter: string): ServidorPublico[] {
    const filterValue = filter.toLowerCase();

    return this.participantes.filter(participante =>
      participante.nombres.toLowerCase().includes(filterValue) ||
      participante.apellidos.toLocaleLowerCase().includes(filterValue) ||
      participante.cargo?.toLowerCase().includes(filterValue) ||
      participante.ciruc.includes(filterValue));
  }


  displayDepartamentoFn(departamento: UnidadOrganizacional): string {
    return departamento && departamento.nombre ? departamento.nombre : '';
  }


  get isEstadisticoReport(): boolean {
    return this.data?.key === 'rptEstadisticoDeptFuncionario' || this.data?.key === 'rptEstadisticoDeptFuncionarioTiempo';
  }

  get isEstadisticoDepartamentalReport(): boolean {
    return this.data?.key === 'rptEstadisticoTareasDepartamental';
  }

  get isTiempoAtencionExportableReport(): boolean {
    return this.data?.key === 'rpTiempoAtencionXLS';
  }

  get isGraficoTipoDocumentoReport(): boolean {
    return this.data?.key === 'rptGrafTramiteDocumento';
  }

  get isTrazabilidadReport(): boolean {
    return this.data?.key === 'rptTrazabilidadTramite';
  }

  get isListadoTramitesGeneralPeriodo(): boolean {
    return this.data?.key === 'rptListadoTramitesGeneralPeriodo';
  }

  get isListadoPorTipoDocumento(): boolean {
    return this.data?.key === 'rpListadoTramitesGeneralPorDocumentoPeriodo';
  }

  get isRecepcionTramiteReport(): boolean {
    return this.data?.reportName === 'rptRecepcionTramiteAmpliado';
  }

  get isRecepcionTramiteAmpliadoReport(): boolean {
    return this.data?.key === 'rptRecepcionTramiteAmpliado';
  }

  selectAllText(event: FocusEvent) {
    const input = event.target as HTMLInputElement;
    input.select();
  }

  private validateFechaInicioFin(): boolean {
    if (!this.frmReporte.controls.fechaInicio.valid || !this.frmReporte.controls.fechaFin.valid) {
      this.snackbarData.message = "Por favor, complete las fechas requeridas."
      this.snackbarData.style = SnackbarStyles.Error
      this.snackbarData.iconName = "error"
      this.toast.show(this.snackbarData);
      return false;
    }
    return true;
  }

  private buildTiempoAtencionParams(encabezado: number, tipoReporte?: string): any {
    const params: any = {
      P_FECHA_INICIO: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaInicio.value!),
      P_FECHA_FIN: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaFin.value!),
      P_ENCABEZADO: encabezado,
      pServidorPublico: this.authService.getTokenData()?.name || '',
    };

    if (tipoReporte) {
      params.tipoReporte = tipoReporte;
    }

    return params;
  }

  onExportar() {
    const reportName = this.data?.key;
    if (reportName !== 'rpTiempoAtencionXLS') {
      return;
    }

    if (!this.validateFechaInicioFin()) {
      return;
    }

    const params = this.buildTiempoAtencionParams(0, 'xls');
    const url: any = this.reportService.getUrl(reportName, params);
    window.open(url, "_blank");
  }

  onSubmit() {
    const reportName = this.data && this.data.key ? this.data.key : 'rptListadoDocumento';

    if (reportName === 'rptTrazabilidadTramite') {
      const anio = this.frmReporte.controls.anio.value;
      const numero = this.frmReporte.controls.numero.value;

      if (!anio || !numero) {
        this.snackbarData.message = "Ingrese año y número del trámite."
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.toast.show(this.snackbarData);
        return;
      }

      if (anio < 0 || numero < 0) {
        this.snackbarData.message = "Año y número no pueden ser negativos"
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.toast.show(this.snackbarData);
        return;
      }

      const params: any = {
        Anio: anio,
        Numero: numero,
        pServidorPublico: this.authService.getTokenData()?.name || '',
      };

      this.reportService.existeTramite(anio, numero).subscribe((existe) => {
        if (!existe) {
          this.snackbarData.message = "El documento no existe"
          this.snackbarData.style = SnackbarStyles.Error
          this.snackbarData.iconName = "error"
          this.toast.show(this.snackbarData);
          return;
        }

        const url: any = this.reportService.getUrl(reportName, params);
        this.openReportBlob(url);
      });
      return;
    }

    if (reportName === 'rptEstadisticoDeptFuncionario' || reportName === 'rptEstadisticoDeptFuncionarioTiempo') {
      // pDepartamento requerido, pFuncionario opcional (-1 = todos)
      if (!this.frmReporte.controls.fechaInicio.valid || !this.frmReporte.controls.fechaFin.valid) {
        this.snackbarData.message = "Por favor, complete las fechas requeridas."
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.toast.show(this.snackbarData);
        return;
      }
      const dpto = this.frmReporte.controls.departamento.value;
      if (!dpto || !(dpto as any).id) {
        this.snackbarData.message = "Seleccione un departamento."
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.toast.show(this.snackbarData);
        return;
      }
      const data = this.frmReporte.value;
      const participante = data.participante as any;
      const funcionarioNombre = participante && (participante.nombres || participante.apellidos)
        ? ((participante.nombres ? participante.nombres : '') + ' ' + (participante.apellidos ? participante.apellidos : '')).trim()
        : (this.authService.getTokenData() ? this.authService.getTokenData()!.name : '');

      const params: any = {
        pFechaInicio: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaInicio.value!),
        pFechaFin: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaFin.value!),
        pDepartamento: (dpto as any).id,
        pFuncionario: (participante && participante.id) ? participante.id : -1,
        pFuncionarioNombre: funcionarioNombre,
        pDepartamentoNombre: (dpto as any).nombre || (dpto as any).id || '',
        pServidorPublico: this.authService.getTokenData()?.name || '',
      };
      const url: any = this.reportService.getUrl(reportName, params);
      this.openReportBlob(url);
      return;
    }

    if (reportName === 'rptEstadisticoTareasDepartamental') {
      if (!this.frmReporte.controls.fechaInicio.valid || !this.frmReporte.controls.fechaFin.valid) {
        this.snackbarData.message = "Por favor, complete las fechas requeridas."
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.toast.show(this.snackbarData);
        return;
      }

      const dpto = this.frmReporte.controls.departamento.value;
      if (!dpto || !(dpto as any).id) {
        this.snackbarData.message = "Seleccione un departamento."
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.toast.show(this.snackbarData);
        return;
      }

      const params: any = {
        P_FECHA_INICIO: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaInicio.value!),
        P_FECHA_FIN: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaFin.value!),
        P_CODIGO_DPTO: (dpto as any).id,
        pServidorPublico: this.authService.getTokenData()?.name || '',
      };

        const url: any = this.reportService.getUrl(reportName, params);
        this.openReportBlob(url);
      return;
    }

    if (reportName === 'rpTiempoAtencionXLS') {
      if (!this.validateFechaInicioFin()) {
        return;
      }

      const params: any = this.buildTiempoAtencionParams(1);

      const url: any = this.reportService.getUrl(reportName, params);
      this.openReportBlob(url);
      return;
    }

    if (reportName === 'rptGrafTramiteDocumento') {
      if (!this.frmReporte.controls.fechaInicio.valid || !this.frmReporte.controls.fechaFin.valid) {
        this.snackbarData.message = "Por favor, complete las fechas requeridas."
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.toast.show(this.snackbarData);
        return;
      }

      const params: any = {
        P_FECHA_INICIO: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaInicio.value!),
        P_FECHA_FIN: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaFin.value!),
        pServidorPublico: this.authService.getTokenData()?.name || '',
      };

      const url: any = this.reportService.getUrl(reportName, params);
      this.openReportBlob(url);
      return;
    }

    if (reportName === 'rptListadoDeptFuncionario') {
      if (!this.frmReporte.controls.fechaInicio.valid || !this.frmReporte.controls.fechaFin.valid) {
        this.snackbarData.message = "Por favor, complete las fechas requeridas."
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.toast.show(this.snackbarData);
        return;
      }
      const data = this.frmReporte.value;
      const params: any = {
        pCodigoParticipante: data.participante?.id || this.currentUserID,
        pFechaInicio: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaInicio.value!),
        pFechaFin: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaFin.value!),
      };
      if (data.departamento && (data.departamento as any).id) params.pDepartamento = (data.departamento as any).id;
      if (data.participante && (data.participante as any).id) params.pFuncionario = (data.participante as any).id;
      const url: any = this.reportService.getUrl(reportName, params);
      this.openReportBlob(url);
      return;
    }

    if (reportName === 'rptListadoDocumentoDeptFuncionario') {
      if (!this.frmReporte.controls.fechaInicio.valid || !this.frmReporte.controls.fechaFin.valid) {
        this.snackbarData.message = "Por favor, complete las fechas requeridas."
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.toast.show(this.snackbarData);
        return;
      }
      const data = this.frmReporte.value;
      const participante = data.participante as any;
      const servidorNombre = (participante && (participante.nombres || participante.apellidos))
        ? ((participante.nombres || '') + ' ' + (participante.apellidos || '')).trim()
        : (this.authService.getTokenData()?.name || '');
      const params: any = {
        pFechaInicio: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaInicio.value!),
        pFechaFin: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaFin.value!),
        pDepartamento: (data.departamento && (data.departamento as any).id) ? (data.departamento as any).id : -1,
        pFuncionario: (participante && participante.id) ? participante.id : -1,
        pServidorPublico: servidorNombre,
      };
      const url: any = this.reportService.getUrl(reportName, params);
      this.openReportBlob(url);
      return;
    }

    if (reportName === 'rptListadoTareasPendienteDepartamento') {
      if (!this.frmReporte.controls.fechaInicio.valid || !this.frmReporte.controls.fechaFin.valid) {
        this.snackbarData.message = "Por favor, complete las fechas requeridas."
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.toast.show(this.snackbarData);
        return;
      }

      const dpto = this.frmReporte.controls.departamento.value;
      if (!dpto || !(dpto as any).id) {
        this.snackbarData.message = "Seleccione un departamento."
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.toast.show(this.snackbarData);
        return;
      }

      const params: any = {
        P_FECHA_INICIO: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaInicio.value!),
        P_FECHA_FIN: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaFin.value!),
        P_CODIGO_DPTO: (dpto as any).id,
        pServidorPublico: this.authService.getTokenData()?.name || '',
      };
      const url: any = this.reportService.getUrl(reportName, params);
      this.openReportBlob(url);
      return;
    }

    if (reportName === 'rptListadoTramitesGeneralPeriodo') {
      if (!this.frmReporte.controls.fechaInicio.valid || !this.frmReporte.controls.fechaFin.valid) {
        this.snackbarData.message = "Por favor, complete las fechas requeridas."
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.toast.show(this.snackbarData);
        return;
      }
      const dpto = this.frmReporte.controls.departamento.value;
      const dptoCodigo = (dpto && (dpto as any).id) ? String((dpto as any).id) : '-100';
      const params: any = {
        P_FECHA_INICIO: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaInicio.value!),
        P_FECHA_FIN: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaFin.value!),
        P_BDEPA_CODIGO: dptoCodigo.startsWith('@') ? dptoCodigo : '@' + dptoCodigo,
        P_HORA_INICIO: this.frmReporte.controls.horaInicio.value || '00:00',
        P_HORA_FIN: this.frmReporte.controls.horaFin.value || '23:59',
        P_CODIGO_TIPO_DOC: this.frmReporte.controls.codigoTipoDoc.value || '-100',
        pServidorPublico: this.authService.getTokenData()?.name || '',
        pDepartamentoNombre: (dpto && (dpto as any).nombre) ? String((dpto as any).nombre) : (dpto && (dpto as any).id ? String((dpto as any).id) : 'TODOS'),
      };
      const url: any = this.reportService.getUrl(reportName, params);
      this.openReportBlob(url);
      return;
    }

    if (reportName === 'rptRecepcionTramiteAmpliado') {
      const anio = this.frmReporte.controls.anio.value;
      const numero = this.frmReporte.controls.numero.value;

      if (!anio || !numero) {
        this.snackbarData.message = "Ingrese año y número del trámite."
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.toast.show(this.snackbarData);
        return;
      }

      this.reportService.existeTramite(anio, numero).subscribe((existe) => {
        if (!existe) {
          this.snackbarData.message = "El documento no existe"
          this.snackbarData.style = SnackbarStyles.Error
          this.snackbarData.iconName = "error"
          this.toast.show(this.snackbarData);
          return;
        }
        const params: any = {
          P_ANIO_TRAMITE: anio,
          P_NUMERO_TRAMITE: String(numero),
          pServidorPublico: this.authService.getTokenData()?.name || '',
        };
        const url: any = this.reportService.getUrl(reportName, params);
        this.openReportBlob(url);
      });
      return;
    }

    if (reportName === 'rpListadoTramitesGeneralPorDocumentoPeriodo') {
      if (!this.frmReporte.controls.fechaInicio.valid || !this.frmReporte.controls.fechaFin.valid) {
        this.snackbarData.message = "Por favor, complete las fechas requeridas."
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.toast.show(this.snackbarData);
        return;
      }
      const params: any = {
        P_FECHA_INICIO: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaInicio.value!),
        P_FECHA_FIN: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaFin.value!),
        P_CODIGO_TIPO_DOC: this.frmReporte.controls.codigoTipoDoc.value || '-100',
        pServidorPublico: this.authService.getTokenData()?.name || '',
      };
      const url: any = this.reportService.getUrl(reportName, params);
      this.openReportBlob(url);
      return;
    }

    if (reportName === 'rpListadoTramitesTipoPeriodo') {
      if (!this.frmReporte.controls.fechaInicio.valid || !this.frmReporte.controls.fechaFin.valid) {
        this.snackbarData.message = "Por favor, complete las fechas requeridas."
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.toast.show(this.snackbarData);
        return;
      }
      const params: any = {
        P_FECHA_INICIO: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaInicio.value!),
        P_FECHA_FIN: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaFin.value!),
        P_CODIGO_TIPO_DOC: this.frmReporte.controls.codigoTipoDoc.value || '-100',
        pServidorPublico: this.authService.getTokenData()?.name || '',
      };
      const url: any = this.reportService.getUrl(reportName, params);
      this.openReportBlob(url);
      return;
    }

    if (reportName === 'rptListadoTareasParticipantePeriodo') {
      if (!this.frmReporte.controls.fechaInicio.valid || !this.frmReporte.controls.fechaFin.valid) {
        this.snackbarData.message = "Por favor, complete las fechas requeridas."
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.toast.show(this.snackbarData);
        return;
      }
      const data = this.frmReporte.value;
      const participante = data.participante as any;
      const servidorNombre = (participante && (participante.nombres || participante.apellidos))
        ? ((participante.nombres || '') + ' ' + (participante.apellidos || '')).trim()
        : (this.authService.getTokenData()?.name || '');
      const params: any = {
        pCodigoParticipante: (participante && participante.id) ? participante.id : this.currentUserID,
        pFechaInicio: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaInicio.value!),
        pFechaFin: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaFin.value!),
        pServidorPublico: servidorNombre,
      };
      const url: any = this.reportService.getUrl(reportName, params);
      this.openReportBlob(url);
      return;
    }

    if (reportName === 'rptGrafTramiteMes') {
      const td = this.authService.getTokenData();
      const params: any = {
        pServidorPublico: td ? td.name : '',
      };
      const url: any = this.reportService.getUrl(reportName, params);
      this.openReportBlob(url);
      return;
    }

    if (reportName === 'rpTareasAbiertasParticipante') {
      const filtro = this.frmReporte.controls.filtroTramite.value || '1';
      const params: any = {
        P_USUARIO: Number(this.currentUserID),
        P_FILTRO_TRAMITE: filtro,
        P_ENCABEZADO: 1,
        pServidorPublico: this.authService.getTokenData()?.name || '',
      };
      const url: any = this.reportService.getUrl(reportName, params);
      this.openReportBlob(url);
      return;
    }

    if (reportName === 'rptBuzonesDeptFuncionarios') {
      const dpto = this.frmReporte.controls.departamento.value as any;
      if (!dpto || !dpto.id) {
        this.snackbarData.message = "Seleccione un departamento."
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.toast.show(this.snackbarData);
        return;
      }

      const params: any = {
        pDepartamento: dpto.id,
        pDepartamentoNombre: dpto.nombre || dpto.descripcion || dpto.id,
        pServidorPublico: this.authService.getTokenData()?.name || '',
      };

      const url: any = this.reportService.getUrl(reportName, params);
      this.openReportBlob(url);
      return;
    }

    // default: require participante
    if (this.frmReporte.valid) {
      const data = this.frmReporte.value;
      const params: any = {
        pCodigoParticipante: data.participante?.id || this.currentUserID,
        pFechaInicio: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaInicio.value!),
        pFechaFin: this.dateService.formatDateDDMMYYYY(this.frmReporte.controls.fechaFin.value!),
        pDepartamento: (data.departamento && (data.departamento as any).id) ? (data.departamento as any).id : -1,
        pFuncionario: (data.participante && (data.participante as any).id) ? (data.participante as any).id : -1,
      };
      const reportName = this.data && this.data.key ? this.data.key : 'rptListadoDocumento';
      const url: any = this.reportService.getUrl(reportName, params);
      this.openReportBlob(url);
    } else {
      this.snackbarData.message = "Por favor, complete todos los campos requeridos."
      this.snackbarData.style = SnackbarStyles.Error
      this.snackbarData.iconName = "error"
      this.toast.show(this.snackbarData);
    }
  }

}
